import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {complement, concat, includes, of} from 'ramda'
import {PLAY} from '../routes'
import {
  selectGameState,
  selectIncorrectTries,
  selectIsComplete,
  selectIsLost,
} from '../selectors/gameState'

export function useGameState() {
  const gameState = useSelector(selectGameState)
  const isComplete = useSelector(selectIsComplete)
  const incorrectTries = useSelector(selectIncorrectTries)
  const isLost = useSelector(selectIsLost)
  const tryLetter = useCallback(
    dispatchLetter(useDispatch(), gameState, isLost, isComplete),
    [gameState],
  )

  return {...gameState, isComplete, incorrectTries, isLost, tryLetter}
}

const notIncludes = complement(includes)

function dispatchLetter(dispatch, {word, tries}, isLost, isComplete) {
  return (letter) => {
    if (notIncludes(letter, tries) && !isLost && !isComplete) {
      return dispatch({
        ...createLocationForDispatch(word, tries, letter),
        meta: {
          location: {
            kind: 'redirect',
          },
        },
      })
    }
  }
}

function createLocationForDispatch(word, tries, letter) {
  return {
    type: PLAY,
    payload: {
      query: {word, tries: concat(tries, of(letter))},
    },
  }
}